/* eslint-disable class-methods-use-this */
import { DayjsUtils } from "src/libs/dayjs-utils";
import { Benefit } from "src/shared/models/benefit.model";
import { VehiclePolicy } from "src/shared/models/vehicle-policy.model";
import { VehiclePolicyUsage } from "src/containers/vehicles/types";
import { PgaPolicy } from "src/shared/models/pga-policy.model";

export class ETNABenefit extends Benefit {
    private static _codes = [
        "AEPlanKilometros",
        "AERoboTotal",
        "AETodoRiesgo1",
        "AETodoRiesgoRedPreferente",
        "AETodoRiesgoSagaFalabella",
        "AETodoRiesgo2",
        "AETodoRiesgoPandero",
        "AETodoRiesgoContacto",
        "AETodoRiesgoMAR",
        "AETodoRiesgoMAF",
        "AETodoRiesgoGILDER",
        "AETodoRiesgoRegatas",
        "AETodoRiesgoMariategui",
        "AETodoRiesgoWillis",
        "AETodoRiesgoMarshRehder",
        "AUTOEnlatadoMarshRehderPlan96",
        "AUTOEnlatadoRoadAssistance",
        "AUTOEnlatadoRC",
    ];

    private static _isPolicyInForce = (policy: VehiclePolicy) => {
        const meetStart = DayjsUtils.getDate(new Date(policy.validityStart));
        const meetEnd = DayjsUtils.getDate(new Date(policy.validityEnd));
        const now = DayjsUtils.getDate(new Date());

        return (
            DayjsUtils.isSameOrBefore(meetStart, now) &&
            DayjsUtils.isSameOrAfter(meetEnd, now)
        );
    };

    private static _isAllowedPolicy = (policy: VehiclePolicy) => {
        const offerCode = policy.offer?.code;
        const productCode = offerCode || policy.product?.code;
        return ETNABenefit._codes.includes(productCode);
    };

    private static _isForParticularUse = (policy: VehiclePolicy) => {
        return policy.vehicle?.usage === VehiclePolicyUsage.Particular;
    };

    static policyHasAccess(policy): boolean {
        const clazz = ETNABenefit;
        const isAllowedPolicy = clazz._isAllowedPolicy(policy);
        const isPolicyInForce = clazz._isPolicyInForce(policy);
        const isForParticularUse = clazz._isForParticularUse(policy);
        return isAllowedPolicy && isPolicyInForce && isForParticularUse;
    }

    // override
    static hasAccess(policies: PgaPolicy[]): boolean {
        return (policies as VehiclePolicy[]).some(ETNABenefit.policyHasAccess);
    }
}
